import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

import { addOpacityToHex } from '@/utils';

export const styles = StyleSheet.create((colors) => ({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: addOpacityToHex(colors.iconPositive, 0.16),
    borderRadius: theme.borderRadius.m,
    paddingHorizontal: theme.spacing[5],
    paddingVertical: theme.spacing[4],
  },
  textContainer: {
    flex: 1,
  },
  savingText: {
    color: colors.textPositive,
  },
  dateText: {
    color: colors.textPositive,
  },
  iconContainer: {
    width: 32,
    height: 32,
    borderRadius: theme.borderRadius.full,
    backgroundColor: addOpacityToHex(colors.iconPositive, 0.4),
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: theme.spacing[4],
  },
}));
